import * as yup from 'yup';
import { compareStrings } from './mapper';

export const createValidation = (schema) => yup.object().shape({ ...schema });

export const isAlphabet = (char = '') => char.toUpperCase() !== char.toLowerCase();

export const isInteger = (value) => Number.isFinite(value);

export const compareObjects = (obj, conditions = {}) => {
  const match = Object.entries(conditions).every(([key, value]) => {
    const objValue = obj?.[key];
    const searchValue = value;
    return compareStrings(searchValue, objValue);
  });
  return match;
};

export const isEven = (num) => num % 2 === 0;

export const isNotUndefiend = (elem) => !!elem;
